import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { getCustomLoading : true, getCustomData: '', getCustomError: false};

export function getCustomReportState(state = initialState, action) {
    switch (action.type) {
        case organisationConstants.REQUEST_GET_CUSTOM_REPORT:
            return {
                getCustomLoading: true,
                getCustomError: false,
                getCustomMessage: ''
            }
        case organisationConstants.RESPONSE_GET_CUSTOM_REPORT:
            return {
                getCustomLoading: false,
                getCustomError: false,
                getCustomData: action.custom_report.data
            }
        case organisationConstants.ERROR_GET_CUSTOM_REPORT:
            return {
                getCustomLoading: false,
                getCustomError: true,
                getCustomData: 'Something went wrong while getting Custom report'
            }
    
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/customReport.reducer.js